module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_2.f087624b.jpg";